<template>
  <div>
    <a-table
      :columns="table.columns"
      :loading="table.loading"
      :data-source="table.data"
      :pagination="false"
      rowKey="webId"
      :scroll="{ x: 1100 }"
    >
      <template slot="housingCover" slot-scope="text, record">
        <div class="cover-cell">
          <img
            v-if="record.tableHousingCover"
            :src="record.tableHousingCover"
            alt="房源封面"
            class="cover-img"
          />
          <span v-else class="cover-empty">暂无封面</span>
        </div>
      </template>

      <template slot="leaseUseType" slot-scope="text, record">
        <span>{{ formatLeaseUseType(record.leaseUseType) }}</span>
      </template>
    </a-table>

    <a-row :gutter="24" v-if="isEditable">
      <a-col :span="12" style="margin: 10px">
        <a-button type="primary" @click="openMapMoudle"
          >手动进行地图标点</a-button
        >
        <a-button style="margin-left: 20px" @click="resetPoint"
          >重置标点</a-button
        >
      </a-col>
    </a-row>
    <TdtMapPoint
      :tk="tk"
      :center="[asset.lng, asset.lat]"
      :zoom="15"
      :markers="generateMarker(asset)"
    />
    <a-modal
      :visible="mapVisible"
      :footer="null"
      :width="1200"
      @cancel="closeMapMoudle"
      centered
      :destroyOnClose="true"
    >
      <div class="map-modal">
        <div class="map-left">
          <TdtSpotMap
            :tk="tk"
            :center="[asset.lng, asset.lat]"
            :zoom="15"
            :pickIcon="require('@/assets/locationMap3.png')"
            @picked="onPicked"
          />
        </div>
        <div class="map-right">
          <div class="map-title">标记信息(请点击地图拾取位置)</div>
          <div class="map-card">
            <div>
              <span class="map-card-label">详细地址：</span>
              <span>{{ mapPointInfo.address || "-" }}</span>
            </div>
            <div>
              <span class="map-card-label">省份/直辖市：</span>
              <span>{{ mapPointInfo.province || "-" }}</span>
            </div>
            <div>
              <span class="map-card-label">城市：</span>
              <span>{{ mapPointInfo.city || "-" }}</span>
            </div>
            <div>
              <span class="map-card-label">街镇：</span>
              <span>{{ mapPointInfo.town || "-" }}</span>
            </div>
            <div>
              <span class="map-card-label">道路：</span>
              <span>{{ mapPointInfo.street || "-" }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 底部按钮（更紧凑） -->
      <div class="map-footer">
        <a-button type="primary" @click="savePoint"> 标点完成 </a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
const columns = [
  {
    title: "封面",
    dataIndex: "housingCover",
    width: 100,
    scopedSlots: { customRender: "housingCover" },
  },
  {
    title: "房源名称",
    dataIndex: "housingResName",
    width: 250,
  },
  {
    title: "房源编号",
    dataIndex: "webId",
    width: 180,
  },
  { title: "详细地址", dataIndex: "housingResAddress", width: 250 },
  {
    title: "租赁用途",
    dataIndex: "leaseUseType",
    width: 150,
    scopedSlots: { customRender: "leaseUseType" },
  },
  { title: "租赁面积（平方米）", dataIndex: "leaseArea", width: 180 },
];
const leaseUseTypeDictionaries = [
  {
    value: "1",
    note: "商业",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "2",
    note: "楼宇办公",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "8",
    note: "园区",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "16",
    note: "仓储",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "32",
    note: "厂房",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "64",
    note: "酒店",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "256",
    note: "住宅",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "512",
    note: "公寓",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "1024",
    note: "工业",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "2048",
    note: "农用",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "4096",
    note: "市政配套",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "8192",
    note: "场地",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "16384",
    note: "其他",
    classify: "ZLPT_ZLYT",
  },
];
import { v4 as uuidv4 } from "uuid";
import TdtMap from "@/components/TdtMap";
import TdtSpotMap from "@/components/TdtSpotMap";
import TdtMapPoint from "@/components/TdtMapPoint";
import { listSelectHouseDetailByIntent } from "@/api/project/Project.js";
export default {
  props: {
    isEditable: {
      type: Boolean,
      default: () => true,
    },
    selectHouseList: {
      type: Array,
      default: () => [],
    },
    intentWebId: {
      type: String,
      default: () => undefined,
    },
    form: {
      type: Object,
      default: () => null,
    },
  },
  components: {
    TdtMap,
    TdtSpotMap,
    TdtMapPoint,
  },
  data() {
    return {
      table: {
        data: [],
        loading: false,
        columns,
      },
      //天地图
      tk: "a3789da931616fce36077d6fd5712667",
      //默认值金山区区政府地址
      asset: {
        lng: 121.337896,
        lat: 30.744028,
      },
      defaultLocation: {
        lng: 121.337896,
        lat: 30.744028,
      },
      //地图开启标志位
      mapVisible: false,
      // 地图标点信息
      mapPointInfo: {
        address: "",
        province: "",
        city: "",
        district: "",
        lng: "",
        lat: "",
      },
    };
  },
  mounted() {
    this.listResource();
  },
  methods: {
    listResource() {
      this.table.loading = true;
      listSelectHouseDetailByIntent({
        intentWebId: this.intentWebId,
        houseListWebId: this.selectHouseList,
      }).then((res) => {
        this.table.data = res.data ? [res.data.baseInfo] : [];
        this.table.loading = false;

        // 将房源信息赋值给form，后续模块适用
        if (res.data && res.data.baseInfo) {
          const result = res.data.baseInfo;

          this.form.rentCount = result.leaseArea;
          this.form.leaseUseType = result.leaseUseType;
          this.form.leaseUseDesc = result.leaseUse;

          if (result && result.lng && result.lat) {
            this.asset = {
              lng: result.lng,
              lat: result.lat,
            };

            this.defaultLocation = {
              lng: result.lng,
              lat: result.lat,
            };

            this.form.longitude = result.lng;
            this.form.dimension = result.lat;
          }
          //房源封面
          this.form.coverPhoto = res.data.housingCover.map((item) => {
            return {
              uid: uuidv4(),
              name: item.fileName,
              status: "done",
              url: item.housingCoverUrl,
            };
          });
          //房源图片
          this.form.projectPhoto = res.data.housingPicture.map((item) => {
            return {
              uid: uuidv4(),
              name: item.fileName,
              status: "done",
              url: item.housingPictureUrl,
            };
          });
        }
      });
    },
    //以下为天地图
    openMapMoudle() {
      (this.mapPointInfo = {
        address: "",
        province: "",
        city: "",
        district: "",
        lng: this.asset.lng,
        lat: this.asset.lat,
      }),
        (this.mapVisible = true);
    },
    closeMapMoudle() {
      this.mapVisible = false;
    },
    savePoint() {
      if (
        !(
          !this.mapPointInfo ||
          !this.mapPointInfo.lng ||
          !this.mapPointInfo.lat
        )
      ) {
        this.asset.lng = this.mapPointInfo.lng;
        this.asset.lat = this.mapPointInfo.lat;
        //同步表格数据
        this.form.longitude = this.mapPointInfo.lng;
        this.form.dimension = this.mapPointInfo.lat;
      }
      this.mapVisible = false;
    },
    generateMarker(asset) {
      if (!asset || !asset.lng || !asset.lat) return [];
      return [
        {
          lng: asset.lng,
          lat: asset.lat,
          icon: require("@/assets/locationMap3.png"),
        },
      ];
    },
    // 地图上选择地点
    onPicked(data) {
      const municipality = [
        "北京市",
        "上海市",
        "天津市",
        "重庆市",
        "台湾省",
        "香港特别行政区",
        "澳门特别行政区",
      ];

      // 如果是直辖市，province 直接等于 city
      if (municipality.includes(data.province)) {
        data.city = data.province;
      }
      // 更新右侧显示用的 info
      this.mapPointInfo = {
        address: data.address,
        province: data.province,
        city: data.city,
        district: data.district,
        town: data.town,
        street: data.street,
        lng: data.lng,
        lat: data.lat,
      };
    },
    resetPoint() {
      this.asset.lng = this.defaultLocation.lng;
      this.asset.lat = this.defaultLocation.lat;

      this.form.longitude = this.defaultLocation.lng;
      this.form.dimension = this.defaultLocation.lat;
    },

    //租赁用途转换
    formatLeaseUseType(value) {
      if (!value) return "-";

      let valueList = [];

      if (Array.isArray(value)) {
        valueList = value;
      } else if (typeof value === "string") {
        try {
          valueList = JSON.parse(value);
        } catch (e) {
          valueList = [value];
        }
      }

      if (!Array.isArray(valueList) || valueList.length === 0) {
        return "-";
      }

      const dictMap = leaseUseTypeDictionaries;

      return valueList
        .map((item) => {
          const match = dictMap.find(
            (dict) => String(dict.value) === String(item)
          );
          return match ? match.note : item;
        })
        .join(";");
    },
  },
};
</script>

<style>
.map-modal {
  display: flex;
  width: 100%;
  border-radius: 6px;
  margin-bottom: 6px;
}
.map-left {
  flex: 9;
  min-width: 0;
  position: relative;
}
.map-right {
  flex: 3;
  border-left: 1px solid #e6e6e6;
  padding: 4px;
  background: #fafafa;
  display: flex;
  flex-direction: column;
}
.map-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 14px;
}
.map-card {
  background: #fff;
  padding: 18px 16px;
  border-radius: 6px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  gap: 14px;
  font-size: 14px;
  color: #444;
}
.map-card-label {
  font-weight: 500;
  color: #666;
}
.map-footer {
  margin-top: 10px;
  width: 100%;
  text-align: center;
}

.cover-cell {
  width: 70px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 4px;
  background: #f5f5f5;
}

.cover-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.cover-empty {
  font-size: 12px;
  color: #999;
}
</style>